import React from 'react';
import { workProcess } from '../data/mock';

const ComeLavoriamo = () => {
  return (
    <div className="come-lavoriamo-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-title">Come <span className="text-brand-red">Lavoriamo</span></h1>
          <div className="accent-line"></div>
          <p className="body-large text-secondary" style={{ maxWidth: '800px', marginTop: '1.5rem' }}>
            Un metodo strutturato in 6 fasi che garantisce precisione, efficienza e continuità operativa
          </p>
        </div>
      </section>

      {/* Process Steps */}
      <section className="section">
        <div className="container">
          <div className="process-timeline">
            {workProcess.map((process, idx) => (
              <div key={process.id} className="process-step">
                <div className="process-step-number">
                  <span className="step-num">{process.step}</span>
                </div>
                <div className="process-step-content">
                  <h2 className="process-step-title">{process.title}</h2>
                  <p className="process-step-description">{process.description}</p>
                </div>
                {idx < workProcess.length - 1 && (
                  <div className="process-connector"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="section section-blue-tint">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">I Nostri Lavori in Azione</h2>
            <div className="accent-line"></div>
            <p className="body-large text-secondary" style={{ marginTop: '1rem' }}>
              Esempi concreti del nostro processo di lavoro su progetti reali
            </p>
          </div>

          <div className="work-gallery">
            <div className="work-image-large">
              <img 
                src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/t098c1ly_3b810e4c-3561-41cb-820d-e8db59828a11.jpg"
                alt="Magazzino logistico"
                className="gallery-image"
              />
              <div className="work-overlay">
                <p className="work-label">Segnaletica Magazzino</p>
              </div>
            </div>
            <div className="work-images-small">
              <div className="work-image-small">
                <img 
                  src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/patsq8a7_0d226dd7-9a9d-4188-b434-44070b461232.jpg"
                  alt="Parcheggio"
                  className="gallery-image"
                />
                <div className="work-overlay">
                  <p className="work-label">Parcheggio</p>
                </div>
              </div>
              <div className="work-image-small">
                <img 
                  src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/htfujoyt_addb4dae-5dd4-46f3-a618-4a3db5c701f4.jpg"
                  alt="Colonnine elettriche"
                  className="gallery-image"
                />
                <div className="work-overlay">
                  <p className="work-label">Colonnine Elettriche</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Commitment */}
      <section className="section">
        <div className="container">
          <div className="quality-section">
            <div className="quality-content">
              <h2 className="section-title">Impegno per la Qualità</h2>
              <div className="accent-line"></div>
              <div className="quality-points">
                <div className="quality-point">
                  <h3 className="quality-point-title">Sicurezza Prima di Tutto</h3>
                  <p className="quality-point-text">
                    Personale formato secondo le normative vigenti, utilizzo di DPI certificati e procedure interne rigorose.
                  </p>
                </div>
                <div className="quality-point">
                  <h3 className="quality-point-title">Controllo Qualità</h3>
                  <p className="quality-point-text">
                    Ogni fase del progetto viene monitorata per garantire i più alti standard qualitativi e normativi.
                  </p>
                </div>
                <div className="quality-point">
                  <h3 className="quality-point-title">Rispetto dell'Ambiente</h3>
                  <p className="quality-point-text">
                    Smaltimento responsabile dei materiali attraverso strutture autorizzate, nel pieno rispetto ambientale.
                  </p>
                </div>
              </div>
            </div>
            <div className="quality-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/ooj1vv3g_9c06e83f-6b5a-4801-a5a4-5f0142e5ae4d.jpg"
                alt="Qualità del lavoro"
                className="image-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .come-lavoriamo-page {
          padding-top: 80px;
        }

        .page-hero {
          padding: var(--space-xl) 0 var(--space-lg);
          background: var(--bg-page);
        }

        .section-header {
          text-align: center;
          margin-bottom: var(--space-lg);
        }

        /* Process Timeline */
        .process-timeline {
          display: flex;
          flex-direction: column;
          gap: 0;
          max-width: 900px;
          margin: 0 auto;
        }

        .process-step {
          position: relative;
          display: grid;
          grid-template-columns: 140px 1fr;
          gap: var(--space-md);
          padding: var(--space-md) 0;
        }

        @media (max-width: 768px) {
          .process-step {
            grid-template-columns: 100px 1fr;
          }
        }

        .process-step-number {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .step-num {
          width: 100px;
          height: 100px;
          background: var(--bg-card);
          border: 3px solid var(--brand-orange);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: 900;
          color: var(--brand-orange);
          transition: all 0.3s ease;
        }

        .process-step:hover .step-num {
          background: var(--brand-orange);
          color: white;
          transform: scale(1.1);
        }

        @media (max-width: 768px) {
          .step-num {
            width: 70px;
            height: 70px;
            font-size: 1.5rem;
          }
        }

        .process-step-content {
          padding: var(--space-sm) 0;
        }

        .process-step-title {
          font-size: 2rem;
          font-weight: 800;
          color: var(--text-primary);
          margin-bottom: 1rem;
          text-transform: uppercase;
        }

        .process-step-description {
          color: var(--text-secondary);
          font-size: 1.125rem;
          line-height: 1.7;
        }

        .process-connector {
          position: absolute;
          left: 70px;
          top: 100%;
          width: 3px;
          height: 100%;
          background: var(--border-light);
        }

        @media (max-width: 768px) {
          .process-connector {
            left: 50px;
          }
        }

        /* Work Gallery */
        .work-gallery {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: var(--space-sm);
          margin-top: var(--space-lg);
        }

        @media (max-width: 1024px) {
          .work-gallery {
            grid-template-columns: 1fr;
          }
        }

        .work-image-large {
          position: relative;
          height: 500px;
          overflow: hidden;
        }

        @media (max-width: 768px) {
          .work-image-large {
            height: 300px;
          }
        }

        .work-images-small {
          display: flex;
          flex-direction: column;
          gap: var(--space-sm);
        }

        .work-image-small {
          position: relative;
          height: 246px;
          overflow: hidden;
        }

        @media (max-width: 1024px) {
          .work-images-small {
            flex-direction: row;
          }

          .work-image-small {
            flex: 1;
            height: 200px;
          }
        }

        @media (max-width: 640px) {
          .work-images-small {
            flex-direction: column;
          }
        }

        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .work-image-large:hover .gallery-image,
        .work-image-small:hover .gallery-image {
          transform: scale(1.05);
        }

        .work-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
          padding: 1.5rem;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .work-image-large:hover .work-overlay,
        .work-image-small:hover .work-overlay {
          opacity: 1;
        }

        .work-label {
          color: white;
          font-size: 1.125rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        /* Quality Section */
        .quality-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--space-lg);
          align-items: center;
        }

        @media (max-width: 1024px) {
          .quality-section {
            grid-template-columns: 1fr;
          }
        }

        .quality-content {
          padding: var(--space-md);
        }

        .quality-points {
          margin-top: var(--space-md);
          display: flex;
          flex-direction: column;
          gap: var(--space-md);
        }

        .quality-point {
          background: var(--bg-card);
          border-left: 4px solid var(--brand-orange);
          padding: 1.5rem;
        }

        .quality-point-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.75rem;
        }

        .quality-point-text {
          color: var(--text-secondary);
          line-height: 1.6;
        }

        .quality-image {
          position: relative;
          height: 600px;
          overflow: hidden;
          border-radius: 0.5rem;
        }

        @media (max-width: 768px) {
          .quality-image {
            height: 300px;
          }
        }

        .image-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </div>
  );
};

export default ComeLavoriamo;
